import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm-batch-stamp',
  templateUrl: './confirm-batch-stamp.component.html',
  styleUrls: ['./confirm-batch-stamp.component.css']
})
export class ConfirmBatchStampComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() options: string[];
  @Input() answer: boolean = false;
  constructor(
    public bsModalRef: BsModalRef,
  ) { }

  ngOnInit() {
  }

  respond(answer: boolean) {
    this.answer = answer;

    this.bsModalRef.hide();
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/popup/confirm-batch-stamp/confirm-batch-stamp.component.ts